<style lang="scss">
.post-reply-page {
  &__file-errors {
    max-height: 200px;
    overflow-y: auto;
  }

  .custom-file-label {
    width: 100%;
    height: 200px !important;
    position: relative;
    border-style: dashed;
    border-width: 4px;
    cursor: pointer;
  }

  .custom-file-input ~ .custom-file-label[data-browse]::after{
    content: none;
  }

  label {
    font-size: 1em;
  }

  .file-upload-text {
    @include centerContent();
    text-align: center;
    font-size: large;

    i {
      font-size: 30pt;
    }

    p:last-child {
      color: $purple-light !important;
    }
  }
}

#modal-progress .close{
  display: none;
}
</style>

<template>
  <!-- eslint-disable -->
  <div class="post-reply-page mb-4">
    <section class="full-width d-flex justify-content-between align-items-center mb-1">
      <h3 class="font-weight-bolder mb-0">Please use the dropzone below to upload your replies.</h3>
      <b-btn class="p-0" variant="link" :to="{name: 'post-reply-search'}">View Replies</b-btn>
    </section>


    <section v-if="fileErrors.length > 0" class="mt-2">
      <h4 class="text-danger">There was a problem with the following files:</h4>
      <ul class="post-reply-page__file-errors">
        <li v-for="file in fileErrors">{{file}}</li>
      </ul>
      <h5>Please check your files and try again.</h5>
    </section>

    <section v-if="progress === 100" class="mt-2 mb-0">
      <h4 class="text-success">Your uploaded replies are now being processed, please check the failure tab in 10 minutes to see any replies that have failed to process</h4>
    </section>

    <section>
      <div class="file-upload-wrapper p-relative">
        <b-form-file
          @input="updateSavedFiles($event)"
          ref="file-input"
          accept=".jpg, .png, .pdf"
          v-model="files"
          multiple
          :state="Boolean(files)"
          placeholder=""
        >
        </b-form-file>
        <section class="file-upload-text">
          <i class="fas fa-upload mb-2"></i>
          <p class="font-weight-bold">Drag and drop here</p>
          <p class="font-weight-bold">or</p>
          <p class="font-weight-bold">Browse files</p>
        </section>
        <div v-if="files.length">You can replace your document(s) by clicking on the dropzone or dropping new files on it.</div>
      </div>

      <b-table v-if="savedFiles.length" class="mt-2" striped hover :items="savedFiles" :fields="headers" sticky-header="250px">
        <template #cell(actions)="data">
         <span class="fas fa-trash pointer"
           @click="savedFiles.splice(data.index, 1)"
         ></span>
        </template>
      </b-table>

      <section class="d-flex full-width justify-content-end">
        <b-button @click="uploadReplies()" :class="{'disabled': savedFiles.length === 0 || loading}"
                  class="mt-1" variant="primary">Upload Replies</b-button>
      </section>
    </section>

    <b-modal id="modal-progress" title="Uploading Replies" hide-footer no-close-on-backdrop no-close-on-esc>
      <b-progress class="my-2 progress-square" :max="100">
        <b-progress-bar class="progress-square" :value="progress" variant="success"></b-progress-bar>
      </b-progress>
    </b-modal>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import RepliesService from '@/services/RepliesService';

export default {
  name: 'PostReplies',
  components: {},
  data() {
    return {
      loading: false,
      savedFiles: [], // files to upload
      files: [], // used for initial storage in v-model file input
      progress: 0,
      numberUploaded: 0,
      fileErrors: [],
      headers: [
        { key: 'name', label: 'file name' },
        { key: 'actions', label: '' },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.appendUploadText();
  },
  methods: {
    appendUploadText() {
      const uploadText = document.querySelector('.file-upload-text');
      document.querySelector('.custom-file-label').append(uploadText);
    },
    uploadReplies() {
      this.resetProgress();
      this.loading = true;
      this.showModal(true);
      const promises = [];

      this.savedFiles.forEach(file => {
        const formData = new FormData();
        formData.append('file', file, file.name);
        promises.push(this.uploadReply(formData));
      });

      Promise.all(promises).then((() => {
        this.$toast.success('Finished Uploading Replies', {
          toastClassName: ['toast-std', 'success-toast'],
        });
      })).finally(() => {
        this.loading = false;
        this.showModal(false);
        this.savedFiles = [];
      });
    },
    updateSavedFiles(files) {
      this.savedFiles = this.savedFiles.concat(files);
      this.files = []; // remove existing files
    },
    uploadReply(file) {
      return RepliesService.uploadReply(file)
        .then(() => {
          this.numberUploaded += 1;
          this.updateProgress();
        }).catch(err => {
          this.fileErrors.push(file.name);
          this.$toast.error(`There was a problem with the file: ${file.name}, please check the file and try again`, {
            toastClassName: ['toast-std', 'warning-toast'],
          });
          console.log('could not upload reply', err);
        });
    },
    showModal(value) {
      if (value) {
        this.$bvModal.show('modal-progress');
      } else {
        this.$bvModal.hide('modal-progress');
      }
    },
    resetProgress() {
      this.progress = 0;
      this.numberUploaded = 0;
      this.fileErrors = [];
    },
    updateProgress() {
      this.progress = (this.numberUploaded / this.savedFiles.length) * 100;
    },
  },
}
</script>
